export var AppointmentAction;
(function (AppointmentAction) {
    AppointmentAction["Confirm"] = "confirm";
    AppointmentAction["Decline"] = "decline";
    AppointmentAction["Cancel"] = "cancel";
    AppointmentAction["Complete"] = "complete";
    AppointmentAction["DidNotHappen"] = "didNotHappen";
    AppointmentAction["Retry"] = "retry";
    AppointmentAction["InProgress"] = "inProgress";
})(AppointmentAction || (AppointmentAction = {}));
export var AppointmentStatus;
(function (AppointmentStatus) {
    AppointmentStatus["Requested"] = "requested";
    AppointmentStatus["Confirmed"] = "confirmed";
    AppointmentStatus["Declined"] = "declined";
    AppointmentStatus["Canceled"] = "canceled";
    AppointmentStatus["InProgress"] = "in_progress";
    AppointmentStatus["Pending"] = "pending";
    AppointmentStatus["Completed"] = "completed";
    AppointmentStatus["DidNotHappen"] = "did_not_happen";
})(AppointmentStatus || (AppointmentStatus = {}));
export var AppointmentType;
(function (AppointmentType) {
    AppointmentType["Free"] = "free";
    AppointmentType["Regular"] = "regular";
    AppointmentType["Volunteer"] = "volunteer";
})(AppointmentType || (AppointmentType = {}));
export var AppointmentVisibility;
(function (AppointmentVisibility) {
    AppointmentVisibility["Private"] = "private";
    AppointmentVisibility["Public"] = "public";
})(AppointmentVisibility || (AppointmentVisibility = {}));
export var AppointmentParticipantStatus;
(function (AppointmentParticipantStatus) {
    AppointmentParticipantStatus["Requested"] = "requested";
    AppointmentParticipantStatus["Confirmed"] = "confirmed";
    AppointmentParticipantStatus["Declined"] = "declined";
    AppointmentParticipantStatus["Canceled"] = "canceled";
    AppointmentParticipantStatus["Completed"] = "completed";
    AppointmentParticipantStatus["DidNotHappen"] = "did_not_happen";
    AppointmentParticipantStatus["PaymentFailed"] = "payment_failed";
})(AppointmentParticipantStatus || (AppointmentParticipantStatus = {}));
//# sourceMappingURL=appointment.js.map